import SuffixMarker from 'services/simplex/suffix-marker';
import Const from 'const';

const suffix = Const.LP_ITEM_DELIMITER + Const.LP_SINGLEGAME_FORCED_STACK_SUFFIX;

const StackItemMarker = {
    suffix,
    ...SuffixMarker,
};

export {StackItemMarker};
